"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CfgCurrencyListCtl = /** @class */ (function (_super) {
    __extends(CfgCurrencyListCtl, _super);
    function CfgCurrencyListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_iso = UIUtils_1.UIUtils.IProp2Str(function (o) { o.iso; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_symbol = UIUtils_1.UIUtils.IProp2Str(function (o) { o.symbol; });
        _this.dk_is_base = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_base; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_is_fun = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_fun; });
        _this.dk_rate = UIUtils_1.UIUtils.IProp2Str(function (o) { o.rate; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    CfgCurrencyListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    CfgCurrencyListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    CfgCurrencyListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListCurrencyGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    iso: resp.list[i].iso,
                    symbol: resp.list[i].symbol,
                    title: resp.list[i].title,
                    is_base: resp.list[i].is_base,
                    rate: resp.list[i].rate,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_deprecated: resp.list[i].is_deprecated,
                    is_fun: resp.list[i].is_fun
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCurrencyListCtl.prototype.ImportCurrency = function (onDone) {
        var _this = this;
        webAApi_1.DoImportCurrency.exec({}, function (resp) {
            _this.Update();
            if (onDone) {
                onDone(resp.rates_added, resp.rates_changed);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCurrencyListCtl.prototype.DoSetIsDeprecatedOne = function (key, isDeprecated, onDone) {
        var _this = this;
        webAApi_1.DoSetAppCurrencyIsDeprecated.exec({ data: { app_currency_id: key, is_deprecated: isDeprecated } }, function (resp) {
            var tmp = _this.getById(key);
            tmp.is_deprecated = isDeprecated;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCurrencyListCtl.prototype.DoSetIsDeprecatedAll = function (isDeprecated, onDone) {
        var _this = this;
        webAApi_1.DoSetAllAppCurrencyIsDeprecated.exec({ data: { is_deprecated: isDeprecated } }, function (resp) {
            for (var i = 0; i < _this.DATA.data.length; i++) {
                _this.DATA.data[i].is_deprecated = isDeprecated;
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCurrencyListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCurrency.exec({
            data: {
                title: data.title,
                is_fun: data.is_fun,
                iso: data.iso,
                rate: data.rate,
                symbol: data.symbol,
                is_deprecated: data.is_deprecated,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                is_base: false,
                is_fun: data.is_fun,
                iso: data.iso,
                symbol: data.symbol,
                rate: data.rate,
                is_deprecated: data.is_deprecated,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgCurrencyListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCurrency.exec({
                data: {
                    app_currency_id: data.key,
                    title: data.title,
                    iso: data.iso,
                    is_fun: data.is_fun,
                    rate: data.rate,
                    symbol: data.symbol,
                    is_deprecated: data.is_deprecated
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.is_fun = data.is_fun;
                _tmp.iso = data.iso;
                _tmp.symbol = data.symbol;
                _tmp.rate = data.rate;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgCurrencyListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CfgCurrencyListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCurrency.exec({ data: { app_currency_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CfgCurrencyListCtl;
}(BaseController_1.BaseController));
exports.CfgCurrencyListCtl = CfgCurrencyListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_currency/ctl/CfgCurrencyListCtl.ts
// module id = 871
// module chunks = 0